import React from 'react';
import { AppRouter } from './AppRouter';
import './index.css';
export function App() {
  return <div className="min-h-screen bg-gray-50 font-sans" data-id="element-0">
      <AppRouter data-id="element-1" />
    </div>;
}